import { commandCounsellorGroupsEditComponent } from "./command-counsellor-groups-edit.component";
import "../command-counsellor-groups.scss";

export const commandCounsellorGroupsEdit = angular
  .module("components.command-counsellor-groups.command-counsellor-groups-edit.commandCounsellorGroupsEdit", [])
  .component("commandCounsellorGroupsEdit", commandCounsellorGroupsEditComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("commandCounsellorGroupsEdit", {
      parent: "app",
      url: "/home/command-counsellor-groups/:group_id/edit",
      breadcrumbName: "Edit group",
      parentState: "commandCounsellorGroupsroute",
      component: "commandCounsellorGroupsEdit",
      resolve: {
        details(CommandCounsellorGroupsService, $stateParams) {
          ("ngInject");
          return CommandCounsellorGroupsService.getGroupById(
            $stateParams.group_id
          );
        },
      },
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-groups/command-counsellor-groups-edit/command-counsellor-groups-edit.module.js